module.exports = __webpack_public_path__ + "static/sc_7-bf93c357f4c3c4abd1fd37c4b2644510.jpg";